import axios from 'axios';

const tagsService = {
    getTags,
    addTag,
    editTag,
    deleteTag
};

async function getTags() {
    return await axios.get('/Tags');
}

async function addTag(tagDetails) {
    return await axios.post('/Tags', tagDetails);
}

async function editTag(tagDetails) {
    return await axios.post('/Tags/Edit', tagDetails);
}

async function deleteTag(tagId) {
    return await axios.delete(`/Tags/${tagId}`);
}

export default tagsService;